import { put, takeLatest } from "redux-saga/effects";
import { actionTypes as homeActionTypes } from "../../Homepage/_redux/homepageRedux";


export const actionTypes = {
  user: "[user] extraWeight",
  setVariable: "[search] setVariable Action",
  changeBackPanel: "[search] ChangeBackPanel Action",
  loadTravels: "[search] loadTravels Action",
  travelsLoaded: "[search] travelsLoaded Action",
  changeSortBy: "[search] changeSortBy Action",
  searchForNewDate: "[search] searchForNewDate Action",
  pickingFilter: "[search] pickingFilter Action",
  serverError: "[search] serverError Action",
  props: "[search] props keeper",
  travelDetails: "[travelDetails] travelDetails",
  extraWeight: "[extraWeight] extraWeight",
  adult: "[adult] extraWeight",
  child: "[child] extraWeight",
  totalPrice: "[totalPrice] extraWeight",
  fullseats: "[fullseats] extraWeight",
  authModal: "[authModal] extraWeight",
  formErrors: "[formErrors] extraWeight",
  favPassengers: "[favPassengers] extraWeight",
  ticketInvoice: "[ticketInvoice] extraWeight",
  ticketDetails: "[ticketDetails] extraWeight",
  filteredTravels: "[filteredTravels] filteredTravels",
  getTicketStatus: "[getTicketStatus] actions",
  isTokenExpired: "[isTokenExpired] actions",
  dynamicPrice: "[dynamicPrice] actions",
  changePhoneNumber: "[search] change phoneNumber Action",
};

export const initialSearchState = {
  user: undefined,
  sortBy: 1,
  departure_date: null,
  departure_time: null,
  arrive_time: null,
  source_stations: [],
  dest_stations: [],
  current_date: null,
  is_results_ready: false,
  is_picking_filter: false,
  server_error: false,
  results: [],
  // round_trip_info_1:{"travel_id":69,"departure_datetime":"2020-09-02T00:00:00","base_price":2500000,"car_type_title":"اتوبوس VIP 25 صندلی","empty_seat_count":25,"duration_over_distance":240,"source_township_id":128,"source_township_title":"زنجان","dest_township_id":1018,"dest_township_title":"تهران","is_midway":false,"riding_time":"2020-09-02T04:30:00","arrived_time":"2020-09-02T08:30:00","direction_source_title":"زنجان","direction_dest_title":"تهران"},
  round_trip_info_1: null,
  round_trip_info_2: null,
  props: [],
  travelDetails: [],
  extraWeight: 0,
  adult: 0,
  child: 0,
  totalPrice: 0,
  fullSeats: [],
  authModal: false,
  formErrors: {},
  favPassengers: [],
  ticketInvoice: undefined,
  ticketDetails: undefined,
  filteredTravels: undefined,
  ticketStatus: undefined,
  isTokenExpired: undefined,
  dynamicPrice: 0,
};

export const reducer = (state = initialSearchState, action) => {
  switch (action.type) {
    case actionTypes.setVariable: {
      const varName = action.varName;
      let prp = { ...state };
      prp[varName] = action.payload;
      return prp;
    }
    case actionTypes.changeBackPanel: {
      return { ...state, backPlan: action.payload };
    }
    case actionTypes.getTicketStatus: {
      return { ...state, ticketStatus: action.payload };
    }
    case actionTypes.ticketDetails: {
      return { ...state, ticketDetails: action.payload };
    }
    case actionTypes.ticketInvoice: {
      return { ...state, ticketInvoice: action.payload };
    }
    case actionTypes.formErrors: {
      return { ...state, formErrors: action.payload };
    }
    case actionTypes.user: {
      return { ...state, user: action.payload };
    }
    case actionTypes.isTokenExpired: {
      return { ...state, isTokenExpired: action.payload };
    }
    case actionTypes.props: {
      const props = action.payload;
      return { ...state, props };
    }
    case actionTypes.authModal: {
      const authModal = action.payload;
      return { ...state, authModal };
    }
    case actionTypes.filteredTravels: {
      const filteredTravels = action.payload;
      return { ...state, filteredTravels };
    }
    case actionTypes.favPassengers: {
      const favPassengers = action.payload;
      return { ...state, favPassengers };
    }
    case actionTypes.extraWeight: {
      const extraWeight = action.payload;
      return { ...state, extraWeight };
    }
    case actionTypes.fullseats: {
      const fullSeats = action.payload;
      return { ...state, fullSeats };
    }
    case actionTypes.travelsLoaded: {
      return { ...state, results: action.payload, is_results_ready: true };
    }
    case actionTypes.travelDetails: {
      const travelDetails = action.payload;
      return { ...state, travelDetails };
    }
    case actionTypes.adult: {
      const adult = action.payload;
      return { ...state, adult };
    }
    case actionTypes.child: {
      const child = action.payload;
      return { ...state, child };
    }
    case actionTypes.totalPrice: {
      const totalPrice = action.payload;
      return { ...state, totalPrice };
    }
    case actionTypes.changeSortBy: {
      return { ...state, sortBy: action.payload, is_results_ready: false };
    }
    case actionTypes.pickingFilter: {
      return { ...state, is_picking_filter: action.payload };
    }
    case actionTypes.serverError: {
      return { ...state, is_results_ready: true, server_error: true };
    }
    case actionTypes.searchForNewDate: {
      return { ...state, is_results_ready: false, departure_date: action.date };
    }
    case actionTypes.dynamicPrice: {
      const totalPrice = action.payload;
      return { ...state, dynamicPrice: totalPrice };
    }
    case actionTypes.changePhoneNumber: {
      const phoneNumber = action.payload;
      return { ...state, phoneNumber: phoneNumber };
    }
    default:
      return { ...state };
  }
};

export const actions = {
  handle_variables: (varName, value) => ({
    type: actionTypes.setVariable,
    varName: varName,
    payload: value,
  }),
  loadTravels: (data) => ({ type: actionTypes.travelsLoaded, payload: data }),
  props: (payload) => ({ type: actionTypes.props, payload }),
  setAdult: (payload) => ({ type: actionTypes.adult, payload }),
  setChild: (payload) => ({ type: actionTypes.child, payload }),
  setTicketDetails: (payload) => ({ type: actionTypes.ticketDetails, payload }),
  setUser: (payload) => ({ type: actionTypes.user, payload }),
  setAuthModal: (payload) => ({ type: actionTypes.authModal, payload }),
  setFormErrors: (payload) => ({ type: actionTypes.formErrors, payload }),
  setTotalPrice: (payload) => ({ type: actionTypes.totalPrice, payload }),
  setTicketInvoice: (payload) => ({ type: actionTypes.ticketInvoice, payload }),
  setFavPassengers: (payload) => ({ type: actionTypes.favPassengers, payload }),
  setFullSeats: (payload) => ({ type: actionTypes.fullseats, payload }),
  extraWeight: (payload) => ({ type: actionTypes.extraWeight, payload }),
  setFilteredTravels: (payload) => ({
    type: actionTypes.filteredTravels,
    payload,
  }),
  getAllTravelDetails: (payload) => ({
    type: actionTypes.travelDetails,
    payload,
  }),
  changeSort: (sortBy) => ({ type: actionTypes.changeSortBy, payload: sortBy }),
  pickingFilter: (state) => ({
    type: actionTypes.pickingFiuseEffectlter,
    payload: state,
  }),
  changeCurrentDay: (date, source_id, dest_id) => {
    return (dispatch) => {
      dispatch({
        type: homeActionTypes.searchForNewDate,
        source_id: source_id,
        dest_id: dest_id,
        date: date,
      });
      dispatch({ type: actionTypes.searchForNewDate, date: date });
    };
  },
  serverErrorOccurred: (date) => ({
    type: actionTypes.serverError,
    payload: date,
  }),
  setTicketStats: (payload) => ({
    type: actionTypes.getTicketStatus,
    payload,
  }),
  setTokenStatus: (payload) => ({
    type: actionTypes.isTokenExpired,
    payload,
  }),
  setDynamicPrice: (payload) => ({
    type: actionTypes.dynamicPrice,
    payload,
  }),
  setPhoneNumber: (payload) => ({
    type: actionTypes.changePhoneNumber,
    payload,
  }),
};

export function* saga() {
  // yield takeLatest(actionTypes.UserRequested, function* userRequested() {
  //     const {data: user} = yield getUserByToken();
  //
  //     yield put(actions.fulfillUser(user));
  // });
}
